import SettingsRoutes from "./settings"
import ProductionRoutes from "./production"
import IntakeRoutes from "./intake"
import FinanceRoutes from "./finance"


export default [
    ...SettingsRoutes,
    ...ProductionRoutes,
    ...IntakeRoutes,
    ...FinanceRoutes,
]